<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card color="primary" class="elevation-1 ae_list aeList">

          <template slot="header">

            <div style="display: grid;grid-template-columns: 1fr auto;padding: 0px 10px 0px 0px;">
              <h4 class="title font-weight-light mb-2" v-text="'Adverse Events'" style="padding:10px"/>

              <div>
                <v-tooltip bottom>
                  <template slot="activator" slot-scope="{ on }">
                    <v-btn v-on="on" :disabled="!filters.protocol_id.value || !pagination.totalItems" color="pink" dark
                      small v-if="$can('execute', 'export_ae_report_mm')" @click="reportMMQuery()">
                      MM Query
                      <v-icon>mdi-file-excel</v-icon>
                    </v-btn>
                  </template>
                  <span>Export MM Query</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template slot="activator" slot-scope="{ on }">
                    <v-btn v-on="on" :disabled="!filters.protocol_id.value || !pagination.totalItems" color="pink" dark
                      small v-if="$can('execute', 'export_ae_report_qc')" @click="reportQualityCheck()">
                      Qualty Check
                      <v-icon>mdi-file-excel</v-icon>
                    </v-btn>
                  </template>
                  <span>Export QC listing</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template slot="activator" slot-scope="{ on }">
                    <v-btn v-on="on"
                      :disabled="!filters.protocol_id.value || filters.case_assessment.value != 'sar' || !pagination.totalItems"
                      color="pink" dark small v-if="$can('execute', 'export_ae_report_sar')" @click="reportSar()">
                      Sar
                      <v-icon>mdi-file-excel</v-icon>
                    </v-btn>
                  </template>
                  <span>Export SAR listing</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template slot="activator" slot-scope="{ on }">
                    <v-btn v-on="on"
                      :disabled="!filters.protocol_id.value || filters.case_assessment.value != 'sae' || !pagination.totalItems"
                      color="pink" dark small v-if="$can('execute', 'export_ae_report_sae')" @click="reportSae()">
                      Sae
                      <v-icon>mdi-file-excel</v-icon>
                    </v-btn>
                  </template>
                  <span>Export SAE Pivot table</span>
                </v-tooltip>


                <v-tooltip bottom>
                  <template slot="activator" slot-scope="{ on }">
                    <v-btn v-on="on" :disabled="!filters.protocol_id.value || !pagination.totalItems || !items.some(item => item.status !== 'Canceled')" color="pink" dark
                      small v-if="$can('execute', 'export_ae_report_rec')" @click="reportRec()">
                      Rec
                      <v-icon>mdi-file-excel</v-icon>
                    </v-btn>
                  </template>
                  <span>Export Reconciliation list</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template slot="activator" slot-scope="{ on }">
                    <v-btn v-on="on" :disabled="!filters.protocol_id.value || !pagination.totalItems || !items.some(item => item.status !== 'Canceled')" color="pink" dark
                      small v-if="$can('execute', 'export_ae_report_complete')" @click="exportExcel()">
                      All
                      <v-icon>mdi-file-excel</v-icon>
                    </v-btn>
                  </template>
                  <span>Export complete excel</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template slot="activator" slot-scope="{ on }">
                    <v-btn v-on="on" v-if="$can('upsert', 'adverse_event')" color="pink" dark small
                      @click="newAdverseEvent()">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>Insert new AE</span>
                </v-tooltip>
              </div>
            </div>
          </template>


          <v-data-table id="ae_dataTable" :headers="headers" :items="items" :pagination="pagination"
            @update:pagination="paginate" :rows-per-page-items="[5, 10, 20]" :total-items="totalItems" :loading="loading"
            prev-icon="mdi-menu-left" next-icon="mdi-menu-right" sort-icon="mdi-menu-down">
            <v-progress-linear slot="progress" color="green" indeterminate></v-progress-linear>

            <template slot="headers" slot-scope="props">
              <tr>
                <th v-for="header in props.headers" :key="header.text" :class="[
                  'column',
                  header.align ? 'text-xs-' + header.align : 'text-xs-left',
                  pagination.descending ? 'desc' : 'asc',
                  header.sortable != false ? 'sortable' : '',
                  header.value === pagination.sortBy ? 'active' : ''
                ]" @click="
                    if (header.sortable != false) {
  changeSort(header.value);
}
  ">
                  <v-icon v-if="header.sortable != false" small>mdi-menu-down</v-icon>
                  <span class="subheading font-weight-dark text-success text-darken-3" v-text="header.text"></span>
                </th>
              </tr>

              <tr class=" lighten-3">
                <th v-for="header in props.headers" :key="header.text">
                  <div v-if="filters.hasOwnProperty(header.value)" style="max-width:200px">
                    <v-text-field :style="filters[header.value].style + ' '" clearable
                      v-if="filters[header.value].type == 'text'" v-model="filters[header.value].value"
                      :placeholder="filters[header.value].placeholder" @input="filterChanged(filters[header.value])" />

                    <v-select :style="filters[header.value].style + ' '" clearable
                      v-if="filters[header.value].type == 'list'" v-model="filters[header.value].value"
                      :items="filters[header.value].list" :item-text="filters[header.value].item_text"
                      :item-value="filters[header.value].item_value" :placeholder="filters[header.value].placeholder"
                      class="purple-input truncate" @change="filterChanged(filters[header.value])"></v-select>

                    <v-autocomplete :style="filters[header.value].style + ' '" clearable
                      v-if="filters[header.value].type == 'autocomplete'" v-model="filters[header.value].value"
                      :items="filters[header.value].list" :item-value="filters[header.value].item_value"
                      :item-text="filters[header.value].item_text" :placeholder="filters[header.value].placeholder"
                      class="purple-input" @change="filterChanged(filters[header.value])"></v-autocomplete>

                    <safety-daterange displayFormat='MM-dd' :style="filters[header.value].style + ' '" clearable
                      v-if="filters[header.value].type == 'daterange'" v-model="filters[header.value].value"
                      :placeholder="filters[header.value].placeholder" class="purple-input"
                      @input="filterChanged(filters[header.value])">
                    </safety-daterange>

                  </div>
                </th>
              </tr>
            </template>

            <template slot="items" slot-scope="{ item }">
              <tr :class="item.is_read ? 'read' : 'unread'" @click="item.expanded = !item.expanded">
                <td :class="canceledClass(item)">{{ item.protocol.name }}</td>
                <td class="text-xs-left" :class="canceledClass(item)">

                  <v-tooltip top>
                    <template slot="activator" slot-scope="{ on }">

                      <span v-on="on">{{ item.cin || '-----' }}</span>

                    </template>
                    <span>{{ item.case_type }}</span>
                  </v-tooltip>


                </td>
                <td class="text-xs-left" :class="canceledClass(item)">

                  <v-tooltip top min-width='100px'>
                    <template slot="activator" slot-scope="{ on }">
                      <div v-on="on">
                        <!-- //issue 257 services -->
                        {{ formatDate(item.receipt_date) }}
                        <!-- //issue 257 services -->
                      </div>
                    </template>
                    <span>On Set Date {{ item.ae_onset_date }}</span>
                  </v-tooltip>

                </td>
                <td class="text-xs-left" :class="canceledClass(item)">{{ item.patient_id }}</td>
                <td class="text-xs-left" :class="canceledClass(item)">
                  <v-tooltip top min-width='500px'>
                    <template slot="activator" slot-scope="{ on }">
                      <div v-on="on">
                        {{ item.site.code }}
                      </div>
                    </template>
                    <span>{{ item.site.name }} - {{ item.site.city }} ({{ item.site.country_code }}) - [{{
                        item.protocol_has_site.code ? item.protocol_has_site.code : '---' }}]</span>
                  </v-tooltip>
                </td>
                <td class="text-xs-left" :class="canceledClass(item)">

                  <v-tooltip top min-width='500px' :disabled="item.ae_verbatim_reported.length <= 25">
                    <template slot="activator" slot-scope="{ on }">
                      <span v-on="on">

                        <a @click="searchCin(item)">
                          <v-tooltip bottom v-if="item.adverse_event_cin.length">
                            <v-icon slot="activator" dense color="orange">mdi-alert-box</v-icon>
                            <span>Same CIN other Term!</span>
                          </v-tooltip>
                        </a>

                        {{ item.ae_verbatim_reported | truncate(25, '...') }}

                      </span>
                    </template>
                    <span> {{ item.ae_verbatim_reported }}</span>
                  </v-tooltip>

                </td>
                <td class="text-xs-left" :class="canceledClass(item)">{{ item.case_assessment }}</td>
                <td class="text-xs-left" :class="canceledClass(item)">
                  <v-tooltip top min-width='500px'>
                    <template slot="activator" slot-scope="{ on }">
                      <v-icon v-on="on" v-if="item.sponsor_triage" color="green">mdi-check</v-icon>
                    </template>
                    <span>{{ item.sponsor_triage }}</span>
                  </v-tooltip>
                </td>
                <td class="text-xs-left" :class="canceledClass(item)">

                  <v-tooltip top min-width='100px' :disabled="!item.errors && !item.canceled_note">
                    <template slot="activator" slot-scope="{ on }">
                      <div v-on="on">
                        {{ item.status }}
                      </div>
                    </template>
                    <span>{{ item.status == 'Canceled' ? item.canceled_note : item.errors }}</span>
                  </v-tooltip>

                </td>


                <td class="text-xs-left">
                  <a flat @click="causalityPdf(item)">
                    <v-icon v-if="item.causality" color="primary">mdi-file-pdf-outline</v-icon>
                  </a>
                </td>


                <td class="text-xs-left">
                  <v-icon v-if="item.company_notification_date" color="green">mdi-check</v-icon>
                  <v-icon v-if="item.medical_notification_date" color="green">mdi-check</v-icon>
                </td>

                <td class="text-xs-right">

                  <v-tooltip top>
                    <template slot="activator" slot-scope="{ on }">
                      <a flat @click="upsertPage(item)" class="ml-2">
                        <v-icon v-if="$can('upsert', 'adverse_event') && item.status != 'Canceled'" v-on="on"
                          color="primary">mdi-pencil</v-icon>
                        <v-icon v-if="!$can('upsert', 'adverse_event') || item.status == 'Canceled'" v-on="on"
                          color="primary">mdi-eye</v-icon>
                      </a>
                    </template>
                    <span v-if="$can('upsert', 'adverse_event')"
                      >Edit Adverse Event - {{ item.id }}</span
                    ><span v-else>View Adverse Event - {{ item.id }}</span>
                  </v-tooltip>


                  <v-tooltip top v-if="$can('upsert', 'adverse_event') && item.status != 'Canceled'">
                    <template slot="activator" slot-scope="{ on }">
                      <a flat @click="confirmDuplicate(item)" class="ml-2">
                        <v-icon v-on="on" color="primary">mdi-content-copy</v-icon>
                      </a>
                    </template>
                    <span>Duplicate Adverse Event - {{ item.id }}</span>
                  </v-tooltip>


                  <v-tooltip top v-if="canDelete(item) && item.status != 'Canceled'">
                    <template slot="activator" slot-scope="{ on }">
                      <a flat @click="confirmDelete(item)" class="ml-2">
                        <v-icon v-on="on" color="primary">mdi-delete-forever</v-icon>
                      </a>
                    </template>
                    <span>Remove Adverse Event - {{ item.id }}</span>
                  </v-tooltip>

                  <v-icon v-if="!canDelete(item) && item.status != 'Canceled'" disabled
                    color="primary">mdi-delete-forever</v-icon>

                  <v-tooltip top>
                    <template slot="activator" slot-scope="{ on }">
                      <a flat @click="openAuditTrail(item)" class="ml-2">
                        <v-icon v-on="on" color="primary">mdi-timeline-clock-outline</v-icon>
                      </a>
                    </template>
                    <span>Audit Trail</span>
                  </v-tooltip>

                </td>
              </tr>

              <tr v-if="item.expanded_">
                <td :colspan="headers.length" style="padding:0px">
                  <v-list two-line dense dark>
                    <v-list-tile>
                      <v-list-tile-content>

                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>

                </td>
              </tr>

            </template>
          </v-data-table>
        </material-card>



        <v-dialog v-model="confirm_delete_dialog" persistent max-width="500px">
          <material-card color="red" title="Delete Adverse Event">
            <v-form ref="form">
              <v-container grid-list-md>
                <v-layout wrap>

                  <v-flex md12>
                    Are you sure you want to delete this Adverse Event <br><b>"{{ selectedItem.cin }} -
                      ({{ selectedItem.id }})"</b> ? <br><br>
                  </v-flex>

                  <v-flex md12>
                    <v-text-field label="Canceled NOTE" v-model="selectedItem.canceled_note" />
                  </v-flex>

                </v-layout>
              </v-container>
            </v-form>
            <v-flex xs12 text-xs-right>
              <v-btn class="mx-1 font-weight-light" color="danger" :disabled="!selectedItem.canceled_note"
                @click="remove()">Delete</v-btn>
              <v-btn class="mx-1 font-weight-light" color="primary" @click="closeDelete()">Cancel</v-btn>
            </v-flex>
          </material-card>
        </v-dialog>


        <v-dialog v-model="confirm_duplicate_dialog" persistent max-width="500px">
          <material-card color="red" title="Duplicate Adverse Event">
            <v-form ref="form">
              <v-container grid-list-md>
                <v-layout wrap>

                  <v-flex md12>
                    Are you sure you want to duplicate this Adverse Event <br><b>"{{ selectedItem.cin }} -
                      ({{ selectedItem.id }})"</b> ? <br>
                  </v-flex>

                </v-layout>
              </v-container>
            </v-form>
            <v-flex xs12 text-xs-right>
              <v-btn class="mx-1 font-weight-light" color="purple" @click="duplicate()">Duplicate</v-btn>
              <v-btn class="mx-1 font-weight-light" color="primary" @click="closeDuplicate()">Cancel</v-btn>
            </v-flex>
          </material-card>
        </v-dialog>


      </v-flex>
    </v-layout>
    <v-dialog v-model="auditTrail.open" width="1200px">
      <safety-audittrail-timeline v-if='auditTrail.open' entity="adverse_event" :entity_id='auditTrail.entityId' :fields="headers"/>
    </v-dialog>
  </v-container>
</template>


<script>
import { subject } from '@casl/ability';
import { normalizeFilters } from "@/utils/filters";
import { getList, remove, duplicate, causalityPdf, upsert } from "@/api/adverse_event";
import { exportExcel, reportSae, reportSar, reportRec, reportQualityCheck, reportMMQuery } from "@/api/report";
import { filters_store } from "./filters";
import { pagination_store } from "./pagination";
//issue 257 services
import moment from 'moment';
//issue 257 services

export default {
  data() {
    return {
      // pagination: {
      //   rowsPerPage: 5,
      //   page: 1,
      //   sortBy: "insert_at",
      //   descending: true
      // },
      loading: true,
      items: [],
      totalItems: 0,
      confirm_delete_dialog: false,
      confirm_duplicate_dialog: false,
      selectedItem: {},
      auditTrail: {
        open: false,
        entityId: null
      },
      headers: [
        { text: "Protocol", align: "left", value: "protocol_id" },
        { text: "Cin", align: "left", value: "cin" },
        { text: "Rec.Date", align: "left", value: "receipt_date" },
        { text: "Patient", align: "left", value: "patient_id", sortable: true },
        { text: "Site", align: "left", value: "site.code", sortable: true },
        { text: "Event", align: "left", value: "ae_verbatim_reported", sortable: false },
        { text: "Type", align: "left", value: "case_assessment", sortable: false },
        { text: "Triage", align: "left", value: "validation_user_triage", sortable: false },
        { text: "Status", align: "left", value: "status", sortable: false },
        { text: "Cslty", align: "left", value: "causality", sortable: false },
        { text: "Sent", valign: "left", value: "sent_to_companies", sortable: false },
        { text: "Actions", value: "actions", sortable: false, align: "right" }
      ],
      filters_store,
      pagination_store,
    };
  },
  computed: {
    filters() {
      this.filters_store['protocol.sponsor_id'] = { value: this.$store.getters.sponsor_id };
      this.filters_store.protocol_id.list = this.$store.getters.protocols;
      return this.filters_store;
    },
    pagination() {
      return this.pagination_store.pagination_deep
    }
  },
  watch: {
    // pagination: {
    //   handler(val, oldVal) {
    //     if (val.page != oldVal.page || val.rowsPerPage != oldVal.rowsPerPage ||  
    //       val.sortBy != oldVal.sortBy || val.descending != oldVal.descending) {
    //       this.getData();
    //     }
    //   },
    //   deep: true
    // },
    // filters: {
    //   handler(val) {
    //     console.log('CHANGED : ', val)
    //     this.pagination.page = 1;
    //     this.getData();
    //   },
    //   deep: true
    // }
  },
  created() {

    this.$store.dispatch("app/loadSponsors");
    this.$store.dispatch("app/sponsorsDisabled", false);

    this.$root.$on('updateAdverseEvents', () => {
      this.getData();
    });

    this.$root.$on('sponsorChanged', (v) => {
      // reset filters
      this.filters_store.protocol_id.value = null
      this.filters_store.cin.value = null
      this.filters_store.patient_id.value = null
      this.filters_store.receipt_date.value = { start: '', end: '' }
      this.filters_store.case_assessment.value = null
      this.filters_store.crf.value = null
      this.filters_store.status.value = null
      this.getData();
    });

    this.$root.$on('showClosedProtocolChanged', (v) => {
      this.filters_store.protocol_id.value = null;
      this.getData();
    });

  },
  mounted() {
    this.getData();
  },
  destroyed() {
    this.$root.$off('sponsorChanged');
    this.$root.$off('updateAdverseEvents');
    this.$root.$off('showClosedProtocolChanged');
  },
  methods: {
    //issue 257 services
    formatDate(x)
    {
      return moment(new Date(x)).format('DD-MMM-YYYY')
    }
    ,
    //issue 257 services
    openAuditTrail (item) {
      this.auditTrail.entityId = item.id
      this.auditTrail.open = true
    },
    getData() {
      this.loading = true;

      let filters = normalizeFilters(
        JSON.parse(JSON.stringify(this.filters))
      );

      if (filters.receipt_date.start == '') {
        delete filters.receipt_date;
      } else {
        let receipt_date_start = '>=' + filters.receipt_date.start;
        let receipt_date_end = '<=' + filters.receipt_date.end;
        filters.receipt_date = receipt_date_start;
        filters['adverse_event.receipt_date'] = receipt_date_end; // TODO same key AND condition in BEEST 
      }

      getList(filters, this.pagination).then(data => {
        data.data.forEach(function (el) {
          el.expanded = false;
        });
        this.items = data.data;
        this.pagination.rowsPerPage = data.perPage;
        this.pagination.page = data.currentPage;
        this.pagination.totalItems = data.tot;
        this.totalItems = data.tot;
        this.loading = false;
      });
    },
    filterChanged() {
      const oldPagination = JSON.parse(JSON.stringify(this.pagination_store.pagination_deep));
      oldPagination.page = 1;
      this.pagination_store.pagination_deep = oldPagination;
      this.getData();
    },
    paginate(v) {
      this.pagination_store.pagination_deep = v
      this.getData();
    },
    sortAlias(col) {
      return this.pagination_store.alias[col] || col;
    },
    changeSort(column) {
      column = this.sortAlias(column);
      const oldPagination = JSON.parse(JSON.stringify(this.pagination_store.pagination_deep));
      oldPagination.page = 1;
      if (oldPagination.sortBy === column) {
        oldPagination.descending = !oldPagination.descending;
      } else {
        oldPagination.sortBy = column;
        oldPagination.descending = true;
      }
      this.pagination_store.pagination_deep = oldPagination;
      this.getData()
    },
    upsertDialog(item = {}) {
      this.$store.dispatch(
        "app/openAdverseEventDialog",
        JSON.parse(JSON.stringify(item))
      );
    },
    upsertPage(item) {
      this.$store.commit('app/adverseEventItem', item);
      this.$router.push('/adverse_event/' + item.id);
    },
    newAdverseEvent() {
      this.$store.commit('app/adverseEventItem', {});
      this.$router.push('/adverse_event');
    },
    canDelete(item) {
      return this.$can('delete', subject('adverse_event', item)) && item.status != 'Canceled';
    },
    confirmDelete(item) {
      this.selectedItem = item;
      this.confirm_delete_dialog = true;
    },
    closeDelete() {
      this.selectedItem = {};
      this.confirm_delete_dialog = false;
    },
    remove() {

      upsert(
        {
          id: this.selectedItem.id,
          canceled_note: this.selectedItem.canceled_note,
          status: 'Canceled'
        }
      ).then(() => {
        // remove(this.selectedItem.id).then( id => {
        this.closeDelete();
        this.getData();
        this.$store.dispatch("app/openSnackbar", {
          message: "Adverse event deleted successfully",
          color: "success"
        });
      }).catch(errorData => {
        this.$store.dispatch("app/openSnackbar", {
          message: "Adverse event Delete error : " + errorData.message,
          color: "error"
        });
      });
    },
    exportExcel() {
      this.$store.dispatch("app/startLoading");
      const filters = JSON.parse(JSON.stringify(this.filters));
      exportExcel(normalizeFilters(filters)).then(d => {

      }).finally(() => {
        this.$store.dispatch("app/stopLoading");
      });
    },
    reportSae() {
      this.$store.dispatch("app/startLoading");
      const filters = JSON.parse(JSON.stringify(this.filters));
      reportSae(normalizeFilters(filters)).then(d => {

      }).finally(() => {
        this.$store.dispatch("app/stopLoading");
      });
    },
    reportSar() {
      this.$store.dispatch("app/startLoading");
      const filters = JSON.parse(JSON.stringify(this.filters));
      reportSar(normalizeFilters(filters)).then(d => {

      }).finally(() => {
        this.$store.dispatch("app/stopLoading");
      });
    },
    reportRec() {
      this.$store.dispatch("app/startLoading");
      const filters = JSON.parse(JSON.stringify(this.filters));
      reportRec(normalizeFilters(filters)).then(d => {

      }).finally(() => {
        this.$store.dispatch("app/stopLoading");
      });
    },
    reportQualityCheck() {
      this.$store.dispatch("app/startLoading");
      const filters = JSON.parse(JSON.stringify(this.filters));
      reportQualityCheck(normalizeFilters(filters), 'adverse_event').then(d => {

      }).finally(() => {
        this.$store.dispatch("app/stopLoading");
      });
    },
    reportMMQuery() {
      this.$store.dispatch("app/startLoading");
      const filters = JSON.parse(JSON.stringify(this.filters));
      reportMMQuery(normalizeFilters(filters), 'adverse_event').then(d => {

      }).finally(() => {
        this.$store.dispatch("app/stopLoading");
      });
    },
    confirmDuplicate(item) {
      this.selectedItem = item;
      this.confirm_duplicate_dialog = true;
    },
    closeDuplicate() {
      this.selectedItem = {};
      this.confirm_duplicate_dialog = false;
    },
    duplicate() {
      duplicate(this.selectedItem.id).then(data => {
        this.getData();
        this.$store.dispatch("app/openSnackbar", {
          message: "Adverse event duplicated successfully",
          color: "success"
        });
      })
        .catch(errorData => {
          this.$store.dispatch("app/openSnackbar", {
            message: "Adverse event Duplicate error : " + errorData.message,
            color: "error"
          });
        })
        .finally(() => {
          this.confirm_duplicate_dialog = false;
        })
    },
    causalityPdf(item) {

      causalityPdf(item.id).then(data => {
        this.$store.dispatch("app/openSnackbar", {
          message: "Causality PDF downloaded correctly",
          color: "success"
        });
      }).catch(e => {
        this.$store.dispatch("app/openSnackbar", {
          message:
            "An Error occurred during the Causality PDF creation. " +
            e.response.data.message,
          color: "error"
        });
      })

    },
    searchCin(item) {
      this.filters_store.cin.value = item.cin
      this.filterChanged()

    },
    canceledClass(item) {
      return item.status == 'Canceled' ? 'canceled' : '';
    }
  },
  filters: {
    truncate: function (text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix;
      }
      return text;
    },
  }
};
</script>

<style lang="scss">
#ae_dataTable {
  .v-datatable__actions {
    color: black;

    .v-btn__content {
      color: black;
    }

    .v-btn {
      background-color: rgb(241, 241, 241);
    }
  }

  tr.lighten-3 th {
    padding: 0px 5px 0px 5px;
  }

  .read td {
    font-size: 14px;
    font-weight: 300;
  }

  .unread td {
    font-weight: bold;
    background: #ffffff;
  }

  .canceled {
    text-decoration: line-through
  }
}

.aeList .v-card--material__header {
  padding: 0px 10px 0px 0px !important;
}
</style>

<style>
/* .ae_list .v-select__selection--comma {
  max-width: 100px !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
} */
</style>